export const translations = {
  he: {
    nav: {
      offersLabel: 'מבצעים',
      offerTechnion: 'בוגרי טכניון',
      offerRaicman: 'בוגרי רייכמן',
      offerMiluim: 'מחבקים מילואים',
      offerFullPrice: 'מחיר מלא',
    },
    landing: {
      heroTitle1: 'המדיה שבה סוף-סוף רואים,',
      heroTitle2: 'זוכרים ושומעים ',
      heroTitle2Bold: 'את הכסף שלך',
      heroTitle2Suffix: '!',
      heroDesc1: 'באמצעות שיתוף פעולה ייחודי עם ',
      heroDesc1Partner: 'Partner TV',
      heroDesc1Rest: ', המותג שלכם נוכח בלמעלה מ-',
      heroDesc1Highlight: '400,000 בתי אב',
      heroDesc1End: ' בישראל – בזמן צפייה והאזנה לתחנות רדיו וערוצי פודקאסטים דרך הטלוויזיה.',
      heroDesc2: 'אלו רגעים נדירים של תשומת לב:',
      heroDesc2Line2: 'מוזיקה, תוכן, רוגע – והמסך פתוח.',
      videoTitle: 'דוגמא לפרסום בטלוויזיה',
      pricingTitle: 'תמחור פשוט ושקוף',
      pricingSubtitle: 'תכנית אחת – פרסום פרימיום של 30 שניות ב־Partner TV.',
      pricePerMonth: 'לחודש',
      feature1: 'מיתוג יוקרתי ונוכחות בולטת',
      feature2: 'הנעה לפעולה ועיצוב ב 4K',
      ctaStart: 'התחל עכשיו',
      faqTitle: 'שאלות נפוצות',
      faq1Q: 'מה זה Partner TV?',
      faq1A: 'Partner TV מציגה פרסום כרקע ויזואלי רגוע בזמן שמאזינים לרדיו ולפודקאסטים בטלוויזיה – בלמעלה מ-400,000 בתי אב בישראל.',
      faq2Q: 'כמה עולה הפרסום?',
      faq2A: 'תכנית אחת – פרסום פרימיום של 30 שניות. המחיר: 15,000 ש״ח לחודש.',
      faq3Q: 'איך מתחילים?',
      faq3A: 'לחצו על "התחל עכשיו" וצרו איתנו קשר. נעזור לכם להכין את הווידאו והעיצוב לפי ההנחיות שלנו.',
      faq4Q: 'מה הדרישות לווידאו?',
      faq4A: 'הווידאו חייב להיות באורך 30 שניות בדיוק, ללא סאונד, בפורמט MP4. יש להנחיות מפורטות בסעיף "הנחיות להעלאת וידאו" למטה.',
      videoGuidelinesTitle: 'הנחיות להעלאת וידאו',
      videoGuidelinesSubtitle: 'פרסום רקע לרדיו ולפודקאסטים בטלוויזיה',
      videoGuidelinesIntro: 'הפלטפורמה מציגה פרסומות כרקע ויזואלי רגוע בזמן שהמאזינים נהנים מתחנות רדיו ופודקאסטים בטלוויזיה. הווידאו לא אמור לדרוש תשומת לב ולהיות מכבד את הסביבה הביתית.',
      videoGuidelinesPrincipleTitle: 'עקרון מנחה',
      videoGuidelinesPrinciple: 'הווידאו צריך להיות נעים למבט וברור שאפשר להתעלם ממנו. אם הצופה מפספס את כל 30 השניות – לא אמור להרגיש שמשהו חסר.',
      videoGuidelinesTechTitle: 'דרישות טכניות',
      videoGuidelinesTech1: 'אורך: בדיוק 30 שניות',
      videoGuidelinesTech2: 'אודיו: אסור (וידאו שקט בלבד)',
      videoGuidelinesTech3: 'פורמט: MP4 (H.264), progressive scan',
      videoGuidelinesTech4: 'מותאם לתצוגה בחלק מהמסך',
      videoGuidelinesTech5: 'להימנע placement של אלמנטים חשובים בחלק העליון (באנר קבוע מוצג שם)',
      videoGuidelinesApprovedTitle: 'סגנונות מאושרים',
      videoGuidelinesApproved1: 'סצנות לייפסטייל אמביינט (בית, אור, סביבות רגועות)',
      videoGuidelinesApproved2: 'מושן אבסטרקטי או של המותג עם צבע, אור או טקסטורה',
      videoGuidelinesApproved3: 'אינטראקציה עם מוצרים בידיים בלבד (בלי פנים)',
      videoGuidelinesNotAllowedTitle: 'אסור (דחייה אוטומטית)',
      videoGuidelinesNotAllowed1: 'ראשים מדברים או פנים',
      videoGuidelinesNotAllowed2: 'כתוביות או טקסט על המסך',
      videoGuidelinesNotAllowed3: 'מחירים, מבצעים או שפת קריאה לפעולה',
      videoGuidelinesNotAllowed4: 'חיתוכים מהירים, נרטיבים או עלילות',
      videoGuidelinesNotAllowed5: 'ניגודיות גבוהה, הבהובים או תנועה אגרסיבית',
      videoGuidelinesNotAllowed6: 'סיפור שתלוי בסאונד',
      videoGuidelinesMotionTitle: 'תנועה ונוחות ויזואלית',
      videoGuidelinesMotion: 'השתמשו בתנועה איטית ורציפה עם מינימום חיתוכים או בלי. שמרו על ניגודיות בינונית עד נמוכה, הימנעו מצבעים אגרסיביים, וודאו שהווידאו מתאים ללופ.',
      videoGuidelinesBrandingTitle: 'כללי מיתוג',
      videoGuidelinesBranding: 'המיתוג חייב להיות עדין. יש להימנע מלוגואים גדולים או ממסרים מבוססי טקסט. הבאנר של הפלטפורמה כבר מספק הקשר – הווידאו לא אמור להתחרות בו.',
      videoGuidelinesApprovalTitle: 'תהליך האישור',
      videoGuidelinesApproval: 'כל הווידאו נבדקים לעמידה טכנית, רגיעות ויזואלית והתאמה לצפייה כרקע. וידאו שלא עומד בהנחיות עלול להידחות או להוסר.',
      videoGuidelinesTagline: 'עיצבו את הווידאו כדי שייראה – לא כדי שיצפו בו.',
    },
    miluim: {
      heroTitle: 'הצעה למילואימניקים',
      heroSubtitle: 'העסק בבעלות 2 מילואימניקים פעילים. אנחנו תומכים במילואימניקים – פרסום פרימיום ב-Partner TV בלמעלה מ-400,000 בתי אב.',
      offerLabel: 'המחיר למילואימניקים:',
      offerPrice: 'חודשיים במקום חודש תמורת 15,000 ש״ח',
      offerPriceBold: 'חודשיים במקום חודש',
      offerPriceRest: ' תמורת 15,000 ש״ח.',
      offerDetail: 'תכנית אחת – פרסום פרימיום של 30 שניות, עיצוב ב-4K והנעה לפעולה.',
      ctaJoin: 'להצטרף להצעה',
      sectionBenefits: 'מה תקבלו',
      benefit1Title: 'נוכחות ב-Partner TV',
      benefit1Text: 'חשיפה בלמעלה מ-400,000 בתי אב בזמן צפייה והאזנה',
      benefit2Title: 'עיצוב ברמת 4K',
      benefit2Text: 'מיתוג יוקרתי והנעה לפעולה מקצועית',
      benefit3Title: 'הצעה למילואימניקים',
      benefit3Text: 'חודשיים במקום חודש – רק למילואימניקים פעילים',
      faqTitle: 'שאלות נפוצות',
      faq1Q: 'למי מיועדת ההצעה?',
      faq1A: 'ההצעה מיועדת למילואימניקים פעילים שמעוניינים לפרסם את העסק או השירות שלהם ב-Partner TV.',
      faq2Q: 'מה כולל הפרסום?',
      faq2A: 'פרסום פרימיום של 30 שניות ב-Partner TV – מיתוג יוקרתי, עיצוב ב-4K והנעה לפעולה. המותג שלכם נוכח בלמעלה מ-400,000 בתי אב בישראל.',
      faq3Q: 'איך מפעילים את ההצעה?',
      faq3A: 'לחצו על "להצטרף להצעה" וכתבו לנו ב-WhatsApp. נאשר שאתם מילואימניקים ונתאים לכם את המחיר.',
      finalTitle: 'מוכנים להתחיל?',
      finalSubtitle: 'צרו איתנו קשר ונתאים לכם את ההצעה',
      footerText: 'GSRadio · Partner TV',
      whatsappMessage: 'הגעתי מדף ההצעה למילואימניקים – אשמח לפרטים',
    },
    raicman: {
      heroTitle: 'הצעה מיוחדת לבוגרי אוניברסיטת רייכמן',
      heroSubtitle: 'פרסום פרימיום ב-Partner TV – מיתוג יוקרתי בלמעלה מ-400,000 בתי אב',
      offerLabel: 'המחיר המיוחד לבוגרים:',
      offerPrice: 'הנחה של 20% – חודש תמורת 1,200 ש״ח',
      offerPriceBold: 'הנחה של 20%',
      offerPriceRest: ' – חודש תמורת 1,200 ש״ח',
      offerDetail: 'תכנית אחת – פרסום של 30 שניות, עיצוב ב-4K והנעה לפעולה.',
      ctaJoin: 'להצטרף להצעה',
      sectionBenefits: 'מה תקבלו',
      benefit1Title: 'נוכחות ב-Partner TV',
      benefit1Text: 'חשיפה בלמעלה מ-400,000 בתי אב בזמן צפייה והאזנה',
      benefit2Title: 'עיצוב ברמת 4K',
      benefit2Text: 'מיתוג יוקרתי והנעה לפעולה מקצועית',
      benefit3Title: 'הצעה בלעדית',
      benefit3Text: 'הנחה של 20% – חודש תמורת 1,200 ש״ח, רק לבוגרי רייכמן',
      faqTitle: 'שאלות נפוצות',
      faq1Q: 'למי מיועדת ההצעה?',
      faq1A: 'ההצעה המיוחדת מיועדת לבוגרי אוניברסיטת רייכמן (Raicman University) שמעוניינים לפרסם את העסק או השירות שלהם ב-Partner TV.',
      faq2Q: 'מה כולל הפרסום?',
      faq2A: 'פרסום פרימיום של 30 שניות ב-Partner TV – מיתוג יוקרתי, עיצוב ב-4K והנעה לפעולה. המותג שלכם נוכח בלמעלה מ-400,000 בתי אב בישראל.',
      faq3Q: 'איך מפעילים את ההצעה?',
      faq3A: 'לחצו על "להצטרף להצעה" וכתבו לנו ב-WhatsApp. נאשר שאתם בוגרים ונתאים לכם את המחיר המיוחד.',
      finalTitle: 'מוכנים להתחיל?',
      finalSubtitle: 'צרו איתנו קשר ונתאים לכם את ההצעה',
      footerText: 'GSRadio · Partner TV',
      whatsappMessage: 'הגעתי מדף בוגרי אוניברסיטת רייכמן – אשמח לפרטים על ההצעה המיוחדת',
    },
    technion: {
      heroTitle: 'הצעה מיוחדת לבוגרי הטכניון',
      heroSubtitle: 'פרסום פרימיום ב-Partner TV – מיתוג יוקרתי בלמעלה מ-400,000 בתי אב',
      offerLabel: 'המחיר המיוחד לבוגרים:',
      offerPrice: 'הנחה של 20% – חודש תמורת 1,200 ש״ח',
      offerPriceBold: 'הנחה של 20%',
      offerPriceRest: ' – חודש תמורת 1,200 ש״ח',
      offerDetail: 'תכנית אחת – פרסום של 30 שניות, עיצוב ב-4K והנעה לפעולה.',
      ctaJoin: 'להצטרף להצעה',
      sectionBenefits: 'מה תקבלו',
      benefit1Title: 'נוכחות ב-Partner TV',
      benefit1Text: 'חשיפה בלמעלה מ-400,000 בתי אב בזמן צפייה והאזנה',
      benefit2Title: 'עיצוב ברמת 4K',
      benefit2Text: 'מיתוג יוקרתי והנעה לפעולה מקצועית',
      benefit3Title: 'הצעה בלעדית',
      benefit3Text: 'הנחה של 20% – חודש תמורת 1,200 ש״ח, רק לבוגרי הטכניון',
      faqTitle: 'שאלות נפוצות',
      faq1Q: 'למי מיועדת ההצעה?',
      faq1A: 'ההצעה המיוחדת מיועדת לבוגרי הטכניון – מכון טכנולוגי לישראל שמעוניינים לפרסם את העסק או השירות שלהם ב-Partner TV.',
      faq2Q: 'מה כולל הפרסום?',
      faq2A: 'פרסום פרימיום של 30 שניות ב-Partner TV – מיתוג יוקרתי, עיצוב ב-4K והנעה לפעולה. המותג שלכם נוכח בלמעלה מ-400,000 בתי אב בישראל.',
      faq3Q: 'איך מפעילים את ההצעה?',
      faq3A: 'לחצו על "להצטרף להצעה" וכתבו לנו ב-WhatsApp. נאשר שאתם בוגרי טכניון ונתאים לכם את המחיר המיוחד.',
      finalTitle: 'מוכנים להתחיל?',
      finalSubtitle: 'צרו איתנו קשר ונתאים לכם את ההצעה',
      footerText: 'GSRadio · Partner TV',
      whatsappMessage: 'הגעתי מדף בוגרי הטכניון – אשמח לפרטים על ההצעה המיוחדת',
    },
  },
  en: {
    nav: {
      offersLabel: 'Offers',
      offerTechnion: 'Technion graduates',
      offerRaicman: 'Raicman graduates',
      offerMiluim: 'Embracing reservists',
      offerFullPrice: 'Full price',
    },
    landing: {
      heroTitle1: 'The media where they finally see,',
      heroTitle2: 'remember and hear ',
      heroTitle2Bold: 'your money',
      heroTitle2Suffix: '!',
      heroDesc1: 'Through a unique partnership with ',
      heroDesc1Partner: 'Partner TV',
      heroDesc1Rest: ', your brand is present in over ',
      heroDesc1Highlight: '400,000 households',
      heroDesc1End: ' in Israel – while watching and listening to radio and podcast channels on TV.',
      heroDesc2: 'These are rare moments of attention:',
      heroDesc2Line2: 'music, content, calm – and the screen is on.',
      videoTitle: 'Sample TV ad',
      pricingTitle: 'Simple, transparent pricing',
      pricingSubtitle: 'One plan – 30-second premium ad on Partner TV.',
      pricePerMonth: 'per month',
      feature1: 'Premium branding and prominent presence',
      feature2: 'Call-to-action and 4K design',
      ctaStart: 'Start now',
      faqTitle: 'FAQ',
      faq1Q: 'What is Partner TV?',
      faq1A: 'Partner TV displays advertising as calm background visuals while listeners enjoy radio and podcasts on TV – in over 400,000 households in Israel.',
      faq2Q: 'How much does advertising cost?',
      faq2A: 'One plan – 30-second premium ad. Price: ₪15,000 per month.',
      faq3Q: 'How do I get started?',
      faq3A: 'Click "Start now" and contact us. We will help you prepare the video and design according to our guidelines.',
      faq4Q: 'What are the video requirements?',
      faq4A: 'Video must be exactly 30 seconds long, no audio, MP4 format. See the "Video upload guidelines" section below for full details.',
      videoGuidelinesTitle: 'Video upload guidelines',
      videoGuidelinesSubtitle: 'Background advertising for radio & podcast on TV',
      videoGuidelinesIntro: 'Our platform displays advertising videos as calm background visuals while listeners enjoy radio stations and podcasts on TV. These videos are not meant to demand attention and must feel respectful of the home environment.',
      videoGuidelinesPrincipleTitle: 'Core principle',
      videoGuidelinesPrinciple: 'Your video should be pleasant to glance at and completely fine to ignore. If the viewer misses the entire 30 seconds, nothing should feel lost.',
      videoGuidelinesTechTitle: 'Technical requirements',
      videoGuidelinesTech1: 'Length: exactly 30 seconds',
      videoGuidelinesTech2: 'Audio: not allowed (silent video only)',
      videoGuidelinesTech3: 'Format: MP4 (H.264), progressive scan',
      videoGuidelinesTech4: 'Designed for partial-screen display',
      videoGuidelinesTech5: 'Avoid placing important visuals near the top edge (persistent banner present)',
      videoGuidelinesApprovedTitle: 'Approved video styles',
      videoGuidelinesApproved1: 'Ambient lifestyle scenes (home, light, calm environments)',
      videoGuidelinesApproved2: 'Abstract or brand motion using color, light, or texture',
      videoGuidelinesApproved3: 'Hands-only interaction with products (no faces)',
      videoGuidelinesNotAllowedTitle: 'Not allowed (automatic rejection)',
      videoGuidelinesNotAllowed1: 'Talking heads or faces',
      videoGuidelinesNotAllowed2: 'Subtitles or on-screen text',
      videoGuidelinesNotAllowed3: 'Prices, promotions, or call-to-action language',
      videoGuidelinesNotAllowed4: 'Fast cuts, narratives, or storylines',
      videoGuidelinesNotAllowed5: 'High contrast, flashing, or aggressive motion',
      videoGuidelinesNotAllowed6: 'Sound-dependent storytelling',
      videoGuidelinesMotionTitle: 'Motion & visual comfort',
      videoGuidelinesMotion: 'Use slow, continuous motion with minimal or no cuts. Maintain medium to low contrast, avoid aggressive colors, and ensure the video is loop-safe.',
      videoGuidelinesBrandingTitle: 'Branding rules',
      videoGuidelinesBranding: 'Branding must be subtle. Avoid large logos or text-based messaging. The platform banner already provides context and your video should not compete with it.',
      videoGuidelinesApprovalTitle: 'Approval process',
      videoGuidelinesApproval: 'All videos are reviewed for technical compliance, visual calmness, and suitability for background viewing. Videos that do not meet these guidelines may be rejected or removed.',
      videoGuidelinesTagline: 'Design your video to be seen, not watched.',
    },
    miluim: {
      heroTitle: 'Offer for reservists',
      heroSubtitle: 'The business is owned by 2 active reservists. We support reservists – premium advertising on Partner TV in over 400,000 households.',
      offerLabel: 'Price for reservists:',
      offerPrice: 'Two months for the price of one for ₪15,000',
      offerPriceBold: 'Two months for the price of one',
      offerPriceRest: ' for ₪15,000.',
      offerDetail: 'One plan – 30-second premium ad, 4K design and call-to-action.',
      ctaJoin: 'Join the offer',
      sectionBenefits: 'What you get',
      benefit1Title: 'Presence on Partner TV',
      benefit1Text: 'Exposure in over 400,000 households while watching and listening',
      benefit2Title: '4K design',
      benefit2Text: 'Premium branding and professional call-to-action',
      benefit3Title: 'Reservists offer',
      benefit3Text: 'Two months for the price of one – for active reservists only',
      faqTitle: 'FAQ',
      faq1Q: 'Who is this offer for?',
      faq1A: 'The offer is for active reservists who want to advertise their business or service on Partner TV.',
      faq2Q: 'What does the ad include?',
      faq2A: 'A 30-second premium ad on Partner TV – premium branding, 4K design and call-to-action. Your brand is present in over 400,000 households in Israel.',
      faq3Q: 'How do I activate the offer?',
      faq3A: 'Click "Join the offer" and message us on WhatsApp. We will confirm you are a reservist and match you with the price.',
      finalTitle: 'Ready to start?',
      finalSubtitle: 'Contact us and we will tailor the offer for you',
      footerText: 'GSRadio · Partner TV',
      whatsappMessage: 'I came from the reservists offer page – I would like details',
    },
    raicman: {
      heroTitle: 'Special offer for Raicman University graduates',
      heroSubtitle: 'Premium advertising on Partner TV – premium branding in over 400,000 households',
      offerLabel: 'Special price for graduates:',
      offerPrice: '20% discount – ₪1,200 per month',
      offerPriceBold: '20% discount',
      offerPriceRest: ' – ₪1,200 per month',
      offerDetail: 'One plan – 30-second ad, 4K design and call-to-action.',
      ctaJoin: 'Join the offer',
      sectionBenefits: 'What you get',
      benefit1Title: 'Presence on Partner TV',
      benefit1Text: 'Exposure in over 400,000 households while watching and listening',
      benefit2Title: '4K design',
      benefit2Text: 'Premium branding and professional call-to-action',
      benefit3Title: 'Exclusive offer',
      benefit3Text: '20% discount – ₪1,200 per month, for Raicman graduates only',
      faqTitle: 'FAQ',
      faq1Q: 'Who is this offer for?',
      faq1A: 'The special offer is for Raicman University graduates who want to advertise their business or service on Partner TV.',
      faq2Q: 'What does the ad include?',
      faq2A: 'A 30-second premium ad on Partner TV – premium branding, 4K design and call-to-action. Your brand is present in over 400,000 households in Israel.',
      faq3Q: 'How do I activate the offer?',
      faq3A: 'Click "Join the offer" and message us on WhatsApp. We will confirm you are a graduate and match you with the special price.',
      finalTitle: 'Ready to start?',
      finalSubtitle: 'Contact us and we will tailor the offer for you',
      footerText: 'GSRadio · Partner TV',
      whatsappMessage: 'I came from the Raicman University graduates page – I would like details on the special offer',
    },
    technion: {
      heroTitle: 'Special offer for Technion graduates',
      heroSubtitle: 'Premium advertising on Partner TV – premium branding in over 400,000 households',
      offerLabel: 'Special price for graduates:',
      offerPrice: '20% discount – ₪1,200 per month',
      offerPriceBold: '20% discount',
      offerPriceRest: ' – ₪1,200 per month',
      offerDetail: 'One plan – 20-second ad, 4K design and call-to-action.',
      ctaJoin: 'Join the offer',
      sectionBenefits: 'What you get',
      benefit1Title: 'Presence on Partner TV',
      benefit1Text: 'Exposure in over 400,000 households while watching and listening',
      benefit2Title: '4K design',
      benefit2Text: 'Premium branding and professional call-to-action',
      benefit3Title: 'Exclusive offer',
      benefit3Text: '20% discount – ₪1,200 per month, for Technion graduates only',
      faqTitle: 'FAQ',
      faq1Q: 'Who is this offer for?',
      faq1A: 'The special offer is for Technion – Israel Institute of Technology graduates who want to advertise their business or service on Partner TV.',
      faq2Q: 'What does the ad include?',
      faq2A: 'A 20-second premium ad on Partner TV – premium branding, 4K design and call-to-action. Your brand is present in over 400,000 households in Israel.',
      faq3Q: 'How do I activate the offer?',
      faq3A: 'Click "Join the offer" and message us on WhatsApp. We will confirm you are a Technion graduate and match you with the special price.',
      finalTitle: 'Ready to start?',
      finalSubtitle: 'Contact us and we will tailor the offer for you',
      footerText: 'GSRadio · Partner TV',
      whatsappMessage: 'I came from the Technion graduates page – I would like details on the special offer',
    },
  },
  ru: {
    nav: {
      offersLabel: 'Акции',
      offerTechnion: 'Выпускники Техниона',
      offerRaicman: 'Выпускники Райхмана',
      offerMiluim: 'Поддержка резервистов',
      offerFullPrice: 'Полная цена',
    },
    landing: {
      heroTitle1: 'Медиа, где наконец видят,',
      heroTitle2: 'помнят и слышат ',
      heroTitle2Bold: 'ваши деньги',
      heroTitle2Suffix: '!',
      heroDesc1: 'Благодаря партнёрству с ',
      heroDesc1Partner: 'Partner TV',
      heroDesc1Rest: ' ваш бренд представлен в более чем ',
      heroDesc1Highlight: '400 000 домохозяйствах',
      heroDesc1End: ' в Израиле – во время просмотра и прослушивания радио и подкастов на ТВ.',
      heroDesc2: 'Это редкие моменты внимания:',
      heroDesc2Line2: 'музыка, контент, спокойствие – и экран включён.',
      videoTitle: 'Пример рекламы на ТВ',
      pricingTitle: 'Простое и прозрачное ценообразование',
      pricingSubtitle: 'Один план – 20-секундная премиум-реклама на Partner TV.',
      pricePerMonth: 'в месяц',
      feature1: 'Премиальный брендинг и заметное присутствие',
      feature2: 'Призыв к действию и дизайн в 4K',
      ctaStart: 'Начать',
      faqTitle: 'Частые вопросы',
      faq1Q: 'Что такое Partner TV?',
      faq1A: 'Partner TV показывает рекламу как спокойный фоновый видеоряд, пока зрители слушают радио и подкасты на ТВ – в более чем 400 000 домохозяйств в Израиле.',
      faq2Q: 'Сколько стоит реклама?',
      faq2A: 'Один план – 20-секундная премиум-реклама. Цена: ₪15,000 в месяц.',
      faq3Q: 'Как начать?',
      faq3A: 'Нажмите «Начать» и свяжитесь с нами. Мы поможем подготовить видео и дизайн по нашим рекомендациям.',
      faq4Q: 'Какие требования к видео?',
      faq4A: 'Видео должно быть ровно 20 секунд, без звука, формат MP4. Подробности в разделе «Рекомендации по загрузке видео» ниже.',
      videoGuidelinesTitle: 'Рекомендации по загрузке видео',
      videoGuidelinesSubtitle: 'Фоновая реклама для радио и подкастов на ТВ',
      videoGuidelinesIntro: 'Наша платформа показывает рекламные ролики как спокойный фон, пока зрители слушают радио и подкасты на ТВ. Ролики не должны привлекать внимание и должны уважать домашнюю обстановку.',
      videoGuidelinesPrincipleTitle: 'Главный принцип',
      videoGuidelinesPrinciple: 'Видео должно быть приятно мельком увидеть и спокойно игнорировать. Если зритель пропустит все 20 секунд – ничего не должно теряться.',
      videoGuidelinesTechTitle: 'Технические требования',
      videoGuidelinesTech1: 'Длина: ровно 20 секунд',
      videoGuidelinesTech2: 'Звук: запрещён (только тихое видео)',
      videoGuidelinesTech3: 'Формат: MP4 (H.264), progressive scan',
      videoGuidelinesTech4: 'Рассчитано на показ на части экрана',
      videoGuidelinesTech5: 'Не размещайте важные элементы у верхнего края (там постоянный баннер)',
      videoGuidelinesApprovedTitle: 'Допустимые стили',
      videoGuidelinesApproved1: 'Кадры быта и окружения (дом, свет, спокойная обстановка)',
      videoGuidelinesApproved2: 'Абстрактное или брендовое движение с цветом, светом или фактурой',
      videoGuidelinesApproved3: 'Только руки с продуктом (без лиц)',
      videoGuidelinesNotAllowedTitle: 'Запрещено (автоотклонение)',
      videoGuidelinesNotAllowed1: 'Говорящие головы или лица',
      videoGuidelinesNotAllowed2: 'Субтитры или текст на экране',
      videoGuidelinesNotAllowed3: 'Цены, акции или призывы к действию',
      videoGuidelinesNotAllowed4: 'Быстрый монтаж, сюжет, история',
      videoGuidelinesNotAllowed5: 'Высокий контраст, мигание, резкое движение',
      videoGuidelinesNotAllowed6: 'Сюжет, зависящий от звука',
      videoGuidelinesMotionTitle: 'Движение и комфорт',
      videoGuidelinesMotion: 'Используйте медленное непрерывное движение, без или с минимумом склеек. Контраст средний или низкий, без агрессивных цветов. Видео должно корректно зацикливаться.',
      videoGuidelinesBrandingTitle: 'Правила брендинга',
      videoGuidelinesBranding: 'Брендинг должен быть сдержанным. Избегайте крупных логотипов и текста. Баннер платформы уже даёт контекст – видео не должно с ним конкурировать.',
      videoGuidelinesApprovalTitle: 'Проверка',
      videoGuidelinesApproval: 'Все ролики проверяются на соответствие техническим требованиям, спокойствию и пригодности для фонового показа. Неподходящие ролики могут быть отклонены или удалены.',
      videoGuidelinesTagline: 'Делайте видео так, чтобы его видели, а не смотрели.',
    },
    miluim: {
      heroTitle: 'Предложение для резервистов',
      heroSubtitle: 'Бизнес принадлежит 2 активным резервистам. Мы поддерживаем резервистов – премиум-реклама на Partner TV в более чем 400 000 домохозяйств.',
      offerLabel: 'Цена для резервистов:',
      offerPrice: 'Два месяца по цене одного за ₪15,000',
      offerPriceBold: 'Два месяца по цене одного',
      offerPriceRest: ' за ₪15,000.',
      offerDetail: 'Один план – 20 секунд рекламы, дизайн 4K и призыв к действию.',
      ctaJoin: 'Присоединиться к предложению',
      sectionBenefits: 'Что вы получаете',
      benefit1Title: 'Присутствие на Partner TV',
      benefit1Text: 'Охват более 400 000 домохозяйств во время просмотра и прослушивания',
      benefit2Title: 'Дизайн в 4K',
      benefit2Text: 'Премиальный брендинг и призыв к действию',
      benefit3Title: 'Предложение для резервистов',
      benefit3Text: 'Два месяца по цене одного – только для активных резервистов',
      faqTitle: 'Частые вопросы',
      faq1Q: 'Для кого это предложение?',
      faq1A: 'Предложение для активных резервистов, которые хотят рекламировать свой бизнес или услуги на Partner TV.',
      faq2Q: 'Что входит в рекламу?',
      faq2A: '20-секундная премиум-реклама на Partner TV – премиальный брендинг, дизайн 4K и призыв к действию. Ваш бренд представлен в более чем 400 000 домохозяйств в Израиле.',
      faq3Q: 'Как активировать предложение?',
      faq3A: 'Нажмите «Присоединиться к предложению» и напишите нам в WhatsApp. Мы подтвердим, что вы резервист, и подберём цену.',
      finalTitle: 'Готовы начать?',
      finalSubtitle: 'Свяжитесь с нами, и мы подберём для вас предложение',
      footerText: 'GSRadio · Partner TV',
      whatsappMessage: 'Я с страницы предложения для резервистов – хотел бы получить детали',
    },
    raicman: {
      heroTitle: 'Специальное предложение для выпускников университета Райхмана',
      heroSubtitle: 'Премиум-реклама на Partner TV – в более чем 400 000 домохозяйств',
      offerLabel: 'Специальная цена для выпускников:',
      offerPrice: 'Скидка 20% – ₪1,200 в месяц',
      offerPriceBold: 'Скидка 20%',
      offerPriceRest: ' – ₪1,200 в месяц',
      offerDetail: 'Один план – 20 секунд рекламы, дизайн 4K и призыв к действию.',
      ctaJoin: 'Присоединиться к предложению',
      sectionBenefits: 'Что вы получаете',
      benefit1Title: 'Присутствие на Partner TV',
      benefit1Text: 'Охват более 400 000 домохозяйств во время просмотра и прослушивания',
      benefit2Title: 'Дизайн в 4K',
      benefit2Text: 'Премиальный брендинг и призыв к действию',
      benefit3Title: 'Эксклюзивное предложение',
      benefit3Text: 'Скидка 20% – ₪1,200 в месяц, только для выпускников Райхмана',
      faqTitle: 'Частые вопросы',
      faq1Q: 'Для кого это предложение?',
      faq1A: 'Специальное предложение для выпускников университета Райхмана, которые хотят рекламировать свой бизнес или услуги на Partner TV.',
      faq2Q: 'Что входит в рекламу?',
      faq2A: '20-секундная премиум-реклама на Partner TV – премиальный брендинг, дизайн 4K и призыв к действию. Ваш бренд представлен в более чем 400 000 домохозяйств в Израиле.',
      faq3Q: 'Как активировать предложение?',
      faq3A: 'Нажмите «Присоединиться к предложению» и напишите нам в WhatsApp. Мы подтвердим, что вы выпускник, и подберём специальную цену.',
      finalTitle: 'Готовы начать?',
      finalSubtitle: 'Свяжитесь с нами, и мы подберём для вас предложение',
      footerText: 'GSRadio · Partner TV',
      whatsappMessage: 'Я с страницы выпускников университета Райхмана – хотел бы получить детали специального предложения',
    },
    technion: {
      heroTitle: 'Специальное предложение для выпускников Техниона',
      heroSubtitle: 'Премиум-реклама на Partner TV – в более чем 400 000 домохозяйств',
      offerLabel: 'Специальная цена для выпускников:',
      offerPrice: 'Скидка 20% – ₪1,200 в месяц',
      offerPriceBold: 'Скидка 20%',
      offerPriceRest: ' – ₪1,200 в месяц',
      offerDetail: 'Один план – 20 секунд рекламы, дизайн 4K и призыв к действию.',
      ctaJoin: 'Присоединиться к предложению',
      sectionBenefits: 'Что вы получаете',
      benefit1Title: 'Присутствие на Partner TV',
      benefit1Text: 'Охват более 400 000 домохозяйств во время просмотра и прослушивания',
      benefit2Title: 'Дизайн в 4K',
      benefit2Text: 'Премиальный брендинг и призыв к действию',
      benefit3Title: 'Эксклюзивное предложение',
      benefit3Text: 'Скидка 20% – ₪1,200 в месяц, только для выпускников Техниона',
      faqTitle: 'Частые вопросы',
      faq1Q: 'Для кого это предложение?',
      faq1A: 'Специальное предложение для выпускников Техниона – Израильского технологического института, которые хотят рекламировать свой бизнес или услуги на Partner TV.',
      faq2Q: 'Что входит в рекламу?',
      faq2A: '20-секундная премиум-реклама на Partner TV – премиальный брендинг, дизайн 4K и призыв к действию. Ваш бренд представлен в более чем 400 000 домохозяйств в Израиле.',
      faq3Q: 'Как активировать предложение?',
      faq3A: 'Нажмите «Присоединиться к предложению» и напишите нам в WhatsApp. Мы подтвердим, что вы выпускник Техниона, и подберём специальную цену.',
      finalTitle: 'Готовы начать?',
      finalSubtitle: 'Свяжитесь с нами, и мы подберём для вас предложение',
      footerText: 'GSRadio · Partner TV',
      whatsappMessage: 'Я с страницы выпускников Техниона – хотел бы получить детали специального предложения',
    },
  },
  ar: {
    nav: {
      offersLabel: 'العروض',
      offerTechnion: 'خريجو التخنيون',
      offerRaicman: 'خريجو رايخمان',
      offerMiluim: 'احتضان الاحتياطيين',
      offerFullPrice: 'السعر الكامل',
    },
    landing: {
      heroTitle1: 'الوسيط الذي يرون فيه أخيراً،',
      heroTitle2: 'يتذكرون ويسمعون ',
      heroTitle2Bold: 'أموالك',
      heroTitle2Suffix: '!',
      heroDesc1: 'من خلال شراكة فريدة مع ',
      heroDesc1Partner: 'Partner TV',
      heroDesc1Rest: '، علامتك التجارية حاضرة في أكثر من ',
      heroDesc1Highlight: '٤٠٠٬٠٠٠ أسرة',
      heroDesc1End: ' في إسرائيل – أثناء المشاهدة والاستماع لمحطات الراديو والبودكاست على التلفزيون.',
      heroDesc2: 'لحظات نادرة من الاهتمام:',
      heroDesc2Line2: 'موسيقى، محتوى، هدوء – والشاشة مفتوحة.',
      videoTitle: 'مثال إعلان تلفزيوني',
      pricingTitle: 'تسعير بسيط وشفاف',
      pricingSubtitle: 'باقة واحدة – إعلان بريميوم ٢٠ ثانية على Partner TV.',
      pricePerMonth: 'شهرياً',
      feature1: 'علامة تجارية راقية وحضور بارز',
      feature2: 'دعوة للعمل وتصميم 4K',
      ctaStart: 'ابدأ الآن',
      faqTitle: 'الأسئلة الشائعة',
      faq1Q: 'ما هو Partner TV؟',
      faq1A: 'Partner TV تعرض الإعلانات كخلفية بصرية هادئة أثناء استماع المستمعين للراديو والبودكاست على التلفزيون – في أكثر من ٤٠٠٬٠٠٠ أسرة في إسرائيل.',
      faq2Q: 'كم تكلفة الإعلان؟',
      faq2A: 'باقة واحدة – إعلان بريميوم ٢٠ ثانية. السعر: ١٬٥٠٠ ش.ج شهرياً. لدينا عروض لخريجي التخنيون ورايخمان والاحتياطيين.',
      faq3Q: 'كيف أبدأ؟',
      faq3A: 'اضغط "ابدأ الآن" وتواصل معنا. سنساعدك في إعداد الفيديو والتصميم حسب إرشاداتنا.',
      faq4Q: 'ما متطلبات الفيديو؟',
      faq4A: 'يجب أن يكون الفيديو ٢٠ ثانية بالضبط، بدون صوت، بصيغة MP4. انظر قسم "إرشادات رفع الفيديو" أدناه للتفاصيل.',
      videoGuidelinesTitle: 'إرشادات رفع الفيديو',
      videoGuidelinesSubtitle: 'إعلان خلفية للراديو والبودكاست على التلفزيون',
      videoGuidelinesIntro: 'تعرض منصتنا إعلانات الفيديو كخلفية بصرية هادئة بينما يستمتع المستمعون بمحطات الراديو والبودكاست على التلفزيون. هذه الفيديوهات لا تهدف لجذب الانتباه ويجب أن تحترم جو المنزل.',
      videoGuidelinesPrincipleTitle: 'المبدأ الأساسي',
      videoGuidelinesPrinciple: 'يجب أن يكون الفيديو مريحاً للنظر ويمكن تجاهله تماماً. إذا فات المشاهد كل ٢٠ ثانية – لا يجب أن يشعر أنه فاته شيء.',
      videoGuidelinesTechTitle: 'المتطلبات التقنية',
      videoGuidelinesTech1: 'المدة: ٢٠ ثانية بالضبط',
      videoGuidelinesTech2: 'الصوت: غير مسموح (فيديو صامت فقط)',
      videoGuidelinesTech3: 'الصيغة: MP4 (H.264)، progressive scan',
      videoGuidelinesTech4: 'مصمم للعرض على جزء من الشاشة',
      videoGuidelinesTech5: 'تجنب وضع عناصر مهمة قرب الحافة العلوية (يوجد بانر ثابت)',
      videoGuidelinesApprovedTitle: 'أنماط فيديو مقبولة',
      videoGuidelinesApproved1: 'مشاهد حياة هادئة (منزل، ضوء، بيئات مريحة)',
      videoGuidelinesApproved2: 'حركة تجريدية أو للعلامة باستخدام اللون أو الضوء أو الملمس',
      videoGuidelinesApproved3: 'تفاعل باليدين فقط مع المنتجات (بدون وجوه)',
      videoGuidelinesNotAllowedTitle: 'غير مسموح (رفض تلقائي)',
      videoGuidelinesNotAllowed1: 'وجوه تتحدث أو وجوه',
      videoGuidelinesNotAllowed2: 'ترجمات أو نص على الشاشة',
      videoGuidelinesNotAllowed3: 'أسعار أو عروض أو لغة دعوة للعمل',
      videoGuidelinesNotAllowed4: 'مقاطع سريعة أو سرد أو حبكة',
      videoGuidelinesNotAllowed5: 'تباين عالٍ أو وميض أو حركة عدوانية',
      videoGuidelinesNotAllowed6: 'سرد يعتمد على الصوت',
      videoGuidelinesMotionTitle: 'الحركة والراحة البصرية',
      videoGuidelinesMotion: 'استخدم حركة بطيئة ومستمرة مع حد أدنى من القص أو بدونه. حافظ على تباين متوسط إلى منخفض، تجنب الألوان العدوانية، وتأكد أن الفيديو يلتف بشكل سليم.',
      videoGuidelinesBrandingTitle: 'قواعد العلامة',
      videoGuidelinesBranding: 'يجب أن يكون العلامة خفيفاً. تجنب الشعارات الكبيرة أو الرسائل النصية. بانر المنصة يقدم السياق بالفعل – لا ينبغي لفيديوك أن ينافسه.',
      videoGuidelinesApprovalTitle: 'عملية الموافقة',
      videoGuidelinesApproval: 'جميع الفيديوهات تُراجع للامتثال التقني والهدوء البصري والملاءمة للعرض الخلفي. الفيديوهات التي لا تلبي هذه الإرشادات قد تُرفض أو تُزال.',
      videoGuidelinesTagline: 'صمم الفيديو لِيُرى، لا لِيُشاهد.',
    },
    miluim: {
      heroTitle: 'عرض للاحتياطيين',
      heroSubtitle: 'المشروع مملوك لمتطوعين احتياطيين. ندعم الاحتياطيين – إعلان بريميوم على Partner TV في أكثر من ٤٠٠٬٠٠٠ أسرة.',
      offerLabel: 'السعر للاحتياطيين:',
      offerPrice: 'شهران بسعر شهر واحد مقابل ١٬٥٠٠ ش.ج',
      offerPriceBold: 'شهران بسعر شهر واحد',
      offerPriceRest: ' مقابل ١٬٥٠٠ ش.ج.',
      offerDetail: 'باقة واحدة – ٢٠ ثانية إعلان، تصميم 4K ودعوة للعمل.',
      ctaJoin: 'انضم إلى العرض',
      sectionBenefits: 'ما الذي تحصل عليه',
      benefit1Title: 'حضور على Partner TV',
      benefit1Text: 'ظهور في أكثر من ٤٠٠٬٠٠٠ أسرة أثناء المشاهدة والاستماع',
      benefit2Title: 'تصميم 4K',
      benefit2Text: 'علامة تجارية راقية ودعوة للعمل احترافية',
      benefit3Title: 'عرض للاحتياطيين',
      benefit3Text: 'شهران بسعر شهر واحد – للاحتياطيين النشطين فقط',
      faqTitle: 'الأسئلة الشائعة',
      faq1Q: 'لمن هذا العرض؟',
      faq1A: 'العرض للاحتياطيين النشطين الراغبين بالإعلان عن أعمالهم أو خدماتهم على Partner TV.',
      faq2Q: 'ماذا يتضمن الإعلان؟',
      faq2A: 'إعلان بريميوم ٢٠ ثانية على Partner TV – علامة راقية، تصميم 4K ودعوة للعمل. علامتك حاضرة في أكثر من ٤٠٠٬٠٠٠ أسرة في إسرائيل.',
      faq3Q: 'كيف أفعّل العرض؟',
      faq3A: 'اضغط "انضم إلى العرض" وراسلنا على واتساب. سنؤكد أنك احتياطي ونطابقك بالسعر.',
      finalTitle: 'مستعد للبدء؟',
      finalSubtitle: 'تواصل معنا وسنلائم لك العرض',
      footerText: 'GSRadio · Partner TV',
      whatsappMessage: 'جئت من صفحة عرض الاحتياطيين – أود تفاصيل',
    },
    raicman: {
      heroTitle: 'عرض خاص لخريجي جامعة رايخمان',
      heroSubtitle: 'إعلان بريميوم على Partner TV – في أكثر من ٤٠٠٬٠٠٠ أسرة',
      offerLabel: 'السعر الخاص للخريجين:',
      offerPrice: 'خصم ٢٠٪ – ١٬٢٠٠ ش.ج شهرياً',
      offerPriceBold: 'خصم ٢٠٪',
      offerPriceRest: ' – ١٬٢٠٠ ش.ج شهرياً',
      offerDetail: 'باقة واحدة – ٢٠ ثانية إعلان، تصميم 4K ودعوة للعمل.',
      ctaJoin: 'انضم إلى العرض',
      sectionBenefits: 'ما الذي تحصل عليه',
      benefit1Title: 'حضور على Partner TV',
      benefit1Text: 'ظهور في أكثر من ٤٠٠٬٠٠٠ أسرة أثناء المشاهدة والاستماع',
      benefit2Title: 'تصميم 4K',
      benefit2Text: 'علامة تجارية راقية ودعوة للعمل احترافية',
      benefit3Title: 'عرض حصري',
      benefit3Text: 'خصم ٢٠٪ – ١٬٢٠٠ ش.ج شهرياً، لخريجي رايخمان فقط',
      faqTitle: 'الأسئلة الشائعة',
      faq1Q: 'لمن هذا العرض؟',
      faq1A: 'العرض الخاص لخريجي جامعة رايخمان الراغبين بالإعلان عن أعمالهم أو خدماتهم على Partner TV.',
      faq2Q: 'ماذا يتضمن الإعلان؟',
      faq2A: 'إعلان بريميوم ٢٠ ثانية على Partner TV – علامة راقية، تصميم 4K ودعوة للعمل. علامتك حاضرة في أكثر من ٤٠٠٬٠٠٠ أسرة في إسرائيل.',
      faq3Q: 'كيف أفعّل العرض؟',
      faq3A: 'اضغط "انضم إلى العرض" وراسلنا على واتساب. سنؤكد أنك خريج ونطابقك بالسعر الخاص.',
      finalTitle: 'مستعد للبدء؟',
      finalSubtitle: 'تواصل معنا وسنلائم لك العرض',
      footerText: 'GSRadio · Partner TV',
      whatsappMessage: 'جئت من صفحة خريجي جامعة رايخمان – أود تفاصيل العرض الخاص',
    },
    technion: {
      heroTitle: 'عرض خاص لخريجي التخنيون',
      heroSubtitle: 'إعلان بريميوم على Partner TV – في أكثر من ٤٠٠٬٠٠٠ أسرة',
      offerLabel: 'السعر الخاص للخريجين:',
      offerPrice: 'خصم ٢٠٪ – ١٬٢٠٠ ش.ج شهرياً',
      offerPriceBold: 'خصم ٢٠٪',
      offerPriceRest: ' – ١٬٢٠٠ ش.ج شهرياً',
      offerDetail: 'باقة واحدة – ٢٠ ثانية إعلان، تصميم 4K ودعوة للعمل.',
      ctaJoin: 'انضم إلى العرض',
      sectionBenefits: 'ما الذي تحصل عليه',
      benefit1Title: 'حضور على Partner TV',
      benefit1Text: 'ظهور في أكثر من ٤٠٠٬٠٠٠ أسرة أثناء المشاهدة والاستماع',
      benefit2Title: 'تصميم 4K',
      benefit2Text: 'علامة تجارية راقية ودعوة للعمل احترافية',
      benefit3Title: 'عرض حصري',
      benefit3Text: 'خصم ٢٠٪ – ١٬٢٠٠ ش.ج شهرياً، لخريجي التخنيون فقط',
      faqTitle: 'الأسئلة الشائعة',
      faq1Q: 'لمن هذا العرض؟',
      faq1A: 'العرض الخاص لخريجي التخنيون – المعهد التكنولوجي لإسرائيل الراغبين بالإعلان عن أعمالهم أو خدماتهم على Partner TV.',
      faq2Q: 'ماذا يتضمن الإعلان؟',
      faq2A: 'إعلان بريميوم ٢٠ ثانية على Partner TV – علامة راقية، تصميم 4K ودعوة للعمل. علامتك حاضرة في أكثر من ٤٠٠٬٠٠٠ أسرة في إسرائيل.',
      faq3Q: 'كيف أفعّل العرض؟',
      faq3A: 'اضغط "انضم إلى العرض" وراسلنا على واتساب. سنؤكد أنك خريج تخنيون ونطابقك بالسعر الخاص.',
      finalTitle: 'مستعد للبدء؟',
      finalSubtitle: 'تواصل معنا وسنلائم لك العرض',
      footerText: 'GSRadio · Partner TV',
      whatsappMessage: 'جئت من صفحة خريجي التخنيون – أود تفاصيل العرض الخاص',
    },
  },
  am: {
    nav: {
      offersLabel: 'ቅናሾች',
      offerTechnion: 'የቴክኒየን ተመራቂዎች',
      offerRaicman: 'የራይክማን ተመራቂዎች',
      offerMiluim: 'ሪዝርቪስቶችን ይደግፉ',
      offerFullPrice: 'ሙሉ ዋጋ',
    },
    landing: {
      heroTitle1: 'ሚዲያ በመጨረሻ የሚያዩት፣',
      heroTitle2: 'የሚያስታውሱና የሚሰሙት ',
      heroTitle2Bold: 'ገንዘብህ',
      heroTitle2Suffix: '!',
      heroDesc1: 'ከ',
      heroDesc1Partner: 'Partner TV',
      heroDesc1Rest: ' ጋር ባለው ልዩ ትብብር በእስራኤል በ',
      heroDesc1Highlight: '400,000 ቤተሰቦች',
      heroDesc1End: ' ብዙ የብራንድ መገኘት – በቴሌቪዥን ራዲዮና ፖድካስት በሚመለከቱበት ጊዜ።',
      heroDesc2: 'እነዚህ ከልብ ትኩረት ያላነሱ ጊዜዎች ናቸው፡',
      heroDesc2Line2: 'ሙዚቃ፣ ይዘት፣ ርስት – እና ስክሪኑ ተከፍቷል።',
      videoTitle: 'የቴሌቪዥን ማስታወቂያ ምሳሌ',
      pricingTitle: 'ቀላል እና ግልጽ የዋጋ ክርክር',
      pricingSubtitle: 'አንድ እቅድ – በPartner TV የ20 ሰከንድ ፕሪሚየም ማስታወቂያ።',
      pricePerMonth: 'በወር',
      feature1: 'ፕሪሚየም ብራንዲንግ እና ግልጽ መገኘት',
      feature2: 'ድርጊት ጥሪ እና 4K ዲዛይን',
      ctaStart: 'አሁን ጀምር',
      faqTitle: 'ተደጋግሞ የሚጠየቁ ጥያቄዎች',
      faq1Q: 'Partner TV ምንድነው?',
      faq1A: 'Partner TV በእስራኤል በ400,000+ ቤተሰቦች ራዲዮና ፖድካስት በቴሌቪዥን በሚያዳምጡ ጊዜ ማስታወቂያን እንደ የተረጋጋ ዳራ ይገልጻል።',
      faq2Q: 'ማስታወቂያ ዋጋ ስንት ነው?',
      faq2A: 'አንድ እቅድ – የ20 ሰከንድ ፕሪሚየም ማስታወቂያ። ዋጋ፡ ₪15,000 በወር።',
      faq3Q: 'እንዴት እጀምራለሁ?',
      faq3A: '"አሁን ጀምር" ጠቅ አድርገህ ያግኙን። በእኛ መመሪያዎች ቪዲዮንና ዲዛይን እንረዳለን።',
      faq4Q: 'ለቪዲዮ መስፈርቶች ምንድነው?',
      faq4A: 'ቪዲዮ 20 ሰከንድ በትክክል፣ ድምጽ የለውም፣ በMP4 ፎርማት መሆን አለበት። ሙሉ ዝርዝሮች ከዚህ በታች "የቪዲዮ ማስገቢያ መመሪያዎች" ይመልከቱ።',
      videoGuidelinesTitle: 'የቪዲዮ ማስገቢያ መመሪያዎች',
      videoGuidelinesSubtitle: 'ራዲዮና ፖድካስት በቴሌቪዥን ዳራ ማስታወቂያ',
      videoGuidelinesIntro: 'መድረካችን ራዲዮና ፖድካስት በቴሌቪዥን በሚያዳምጡ ጊዜ ማስታወቂያ ቪዲዮዎችን እንደ የተረጋጋ ዳራ ይገልጻል። እነዚህ ቪዲዮዎች ትኩረት እንዳይጠይቁ እና የቤት አካባቢን እንዲያከብሩ ይገባል።',
      videoGuidelinesPrincipleTitle: 'መሠረታዊ መርህ',
      videoGuidelinesPrinciple: 'ቪዲዮዎ ለመመልከት የሚያስደስት እና ሙሉ በሙሉ ችላ የሚባል መሆን አለበት። ተመልካቹ ሙሉውን 20 ሰከንድ ቢያመልክት ምንም ማጣት አይገባውም።',
      videoGuidelinesTechTitle: 'ቴክኒካል መስፈርቶች',
      videoGuidelinesTech1: 'ርዝመት፡ በትክክል 20 ሰከንድ',
      videoGuidelinesTech2: 'ድምጽ፡ አይፈቀድም (ድምጽ የሌለው ቪዲዮ ብቻ)',
      videoGuidelinesTech3: 'ፎርማት፡ MP4 (H.264)፣ progressive scan',
      videoGuidelinesTech4: 'ለከፊል ስክሪን ማሳያ የተነደፈ',
      videoGuidelinesTech5: 'አስፈላጊ ቪዲዮዎችን ከላይኛው ጫፍ አቅራቢያ አያስቀምጡ (ቋሚ ባነር አለ)',
      videoGuidelinesApprovedTitle: 'የሚፈቀዱ የቪዲዮ ዘዴዎች',
      videoGuidelinesApproved1: 'የአካባቢ የህይወት ዘገባዎች (ቤት፣ ብርሃን፣ የተረጋጋ አካባቢዎች)',
      videoGuidelinesApproved2: 'አብስትራክት ወይም የብራንድ እንቅስቃሴ በቀለም፣ ብርሃን ወይም ጥምጥም',
      videoGuidelinesApproved3: 'ከምርቶች ጋር በእጅ ብቻ መስራት (ፊት የለውም)',
      videoGuidelinesNotAllowedTitle: 'አይፈቀድም (ራስ-ሰር ማጥፋት)',
      videoGuidelinesNotAllowed1: 'የሚናገሩ ጭንቅላቶች ወይም ፊቶች',
      videoGuidelinesNotAllowed2: 'ንዑስ ርዕሶች ወይም በስክሪን ላይ ጽሑፍ',
      videoGuidelinesNotAllowed3: 'ዋጋዎች፣ ማስተዋወቂያዎች ወይም የድርጊት ጥሪ ቋንቋ',
      videoGuidelinesNotAllowed4: 'ፈጣን ቁርጥ፣ ታሪኮች ወይም የታሪክ መስመሮች',
      videoGuidelinesNotAllowed5: 'ከፍተኛ ኮንትራስት፣ ብርሃን መድረቅ ወይም ጠንካራ እንቅስቃሴ',
      videoGuidelinesNotAllowed6: 'በድምጽ ላይ የተመሰረተ ታሪክ',
      videoGuidelinesMotionTitle: 'እንቅስቃሴ እና የማይክ አስተማማኝነት',
      videoGuidelinesMotion: 'ዝግ ቀጣይነት ያለው እንቅስቃሴ በትንሽ ወይም ያለ ቁርጥ ይጠቀሙ። መካከለኛ እስከ ዝቅተኛ ኮንትራስት ይጠብቁ፣ ጠንካራ ቀለሞችን ያስወግዱ፣ ቪዲዮው ለሉፕ ደህን መሆኑን ያረጋግጡ።',
      videoGuidelinesBrandingTitle: 'የብራንድ ህጎች',
      videoGuidelinesBranding: 'ብራንዲንግ ትንሽ መሆን አለበት። ትልልቅ ሎጎዎችን ወይም በጽሑፍ ላይ የተመሰረቱ መልዕክቶችን ያስወግዱ። የመድረኩ ባነር ቀድሞውኑ እርዳታ ይሰጣል – ቪዲዮዎ ከእሱ ጋር አይወዳደርም።',
      videoGuidelinesApprovalTitle: 'የማረጋገጫ ሂደት',
      videoGuidelinesApproval: 'ሁሉም ቪዲዮዎች ለቴክኒካል ተጣራሪነት፣ የማይክ አረጋጋጭነት እና ለዳራ እይታ ብቃት ይገምገማሉ። ከእነዚህ መመሪያዎች የማይጣጣሙ ቪዲዮዎች ሊጣሉ ወይም ሊሰረዙ ይችላሉ።',
      videoGuidelinesTagline: 'ቪዲዮዎን ለማየት ይንደፉ፣ ለማጣራት አይደለም።',
    },
    miluim: {
      heroTitle: 'ለሪዝርቪስቶች ቅናሽ',
      heroSubtitle: 'ንግዱ በ2 ንቁ ሪዝርቪስቶች ይይዛል። ሪዝርቪስቶችን እንደጋገርናል – በPartner TV በ400,000+ ቤተሰቦች ፕሪሚየም ማስታወቂያ።',
      offerLabel: 'ለሪዝርቪስቶች ዋጋ፡',
      offerPrice: 'ሁለት ወር በአንድ ዋጋ በ₪15,000',
      offerPriceBold: 'ሁለት ወር በአንድ ዋጋ',
      offerPriceRest: ' በ₪15,000።',
      offerDetail: 'አንድ እቅድ – 20 ሰከንድ ማስታወቂያ፣ 4K ዲዛይን እና ድርጊት ጥሪ።',
      ctaJoin: 'ቅናሹን ይቀላቀሉ',
      sectionBenefits: 'ምን ያገኛሉ',
      benefit1Title: 'በPartner TV መገኘት',
      benefit1Text: 'በ400,000+ ቤተሰቦች በሚመለከቱበት ጊዜ ትጋት',
      benefit2Title: '4K ዲዛይን',
      benefit2Text: 'ፕሪሚየም ብራንዲንግ እና ፕሮፌሽናል ድርጊት ጥሪ',
      benefit3Title: 'ለሪዝርቪስቶች ቅናሽ',
      benefit3Text: 'ሁለት ወር በአንድ ዋጋ – ለንቁ ሪዝርቪስቶች ብቻ',
      faqTitle: 'ተደጋግሞ የሚጠየቁ ጥያቄዎች',
      faq1Q: 'ይህ ቅናሽ ለማን ነው?',
      faq1A: 'ቅናሹ ለንቁ ሪዝርቪስቶች ቢዝነስ ወይም አገልግሎት በPartner TV ለማስታወቅ ለሚፈልጉ ነው።',
      faq2Q: 'ማስታወቂያው ምን ያካትታል?',
      faq2A: 'በPartner TV የ20 ሰከንድ ፕሪሚየም ማስታወቂያ – ፕሪሚየም ብራንዲንግ፣ 4K ዲዛይን። ብራንድህ በእስራኤል በ400,000+ ቤተሰቦች ይገኛል።',
      faq3Q: 'ቅናሹን እንዴት እንቅማለላለሁ?',
      faq3A: '"ቅናሹን ይቀላቀሉ" ጠቅ አድርገህ በWhatsApp ጻፍልን። ሪዝርቪስት መሆንህን እናረጋግጣለን ዋጋ እንሰጥሃለን።',
      finalTitle: 'ለመጀመር ተዘጋጅተዋል?',
      finalSubtitle: 'ያግኙን እና ቅናሹን እናስተካክልልዎታለን',
      footerText: 'GSRadio · Partner TV',
      whatsappMessage: 'ከሪዝርቪስቶች ቅናሽ ገጽ መጣሁ – ዝርዝሮች እፈልጋለሁ',
    },
    raicman: {
      heroTitle: 'ለራይክማን ዩኒቨርሲቲ ተመራቂዎች ልዩ ቅናሽ',
      heroSubtitle: 'በPartner TV ፕሪሚየም ማስታወቂያ – በ400,000+ ቤተሰቦች',
      offerLabel: 'ለተመራቂዎች ልዩ ዋጋ፡',
      offerPrice: '20% ቅናሽ – ₪1,200 በወር',
      offerPriceBold: '20% ቅናሽ',
      offerPriceRest: ' – ₪1,200 በወር',
      offerDetail: 'አንድ እቅድ – 20 ሰከንድ ማስታወቂያ፣ 4K ዲዛይን እና ድርጊት ጥሪ።',
      ctaJoin: 'ቅናሹን ይቀላቀሉ',
      sectionBenefits: 'ምን ያገኛሉ',
      benefit1Title: 'በPartner TV መገኘት',
      benefit1Text: 'በ400,000+ ቤተሰቦች በሚመለከቱበት ጊዜ ትጋት',
      benefit2Title: '4K ዲዛይን',
      benefit2Text: 'ፕሪሚየም ብራንዲንግ እና ፕሮፌሽናል ድርጊት ጥሪ',
      benefit3Title: 'ልዩ ቅናሽ',
      benefit3Text: '20% ቅናሽ – ₪1,200 በወር፣ ለራይክማን ተመራቂዎች ብቻ',
      faqTitle: 'ተደጋግሞ የሚጠየቁ ጥያቄዎች',
      faq1Q: 'ይህ ቅናሽ ለማን ነው?',
      faq1A: 'ልዩ ቅናሹ ለራይክማን ዩኒቨርሲቲ ተመራቂዎች ቢዝነስ ወይም አገልግሎት በPartner TV ለማስታወቅ ለሚፈልጉ ነው።',
      faq2Q: 'ማስታወቂያው ምን ያካትታል?',
      faq2A: 'በPartner TV የ20 ሰከንድ ፕሪሚየም ማስታወቂያ – ፕሪሚየም ብራንዲንግ፣ 4K ዲዛይን። ብራንድህ በእስራኤል በ400,000+ ቤተሰቦች ይገኛል።',
      faq3Q: 'ቅናሹን እንዴት እንቅማለላለሁ?',
      faq3A: '"ቅናሹን ይቀላቀሉ" ጠቅ አድርገህ በWhatsApp ጻፍልን። ተመራቂ መሆንህን እናረጋግጣለን ልዩ ዋጋ እንሰጥሃለን።',
      finalTitle: 'ለመጀመር ተዘጋጅተዋል?',
      finalSubtitle: 'ያግኙን እና ቅናሹን እናስተካክልልዎታለን',
      footerText: 'GSRadio · Partner TV',
      whatsappMessage: 'ከራይክማን ተመራቂዎች ገጽ መጣሁ – ለልዩ ቅናሹ ዝርዝሮች እፈልጋለሁ',
    },
    technion: {
      heroTitle: 'ለቴክኒየን ተመራቂዎች ልዩ ቅናሽ',
      heroSubtitle: 'በPartner TV ፕሪሚየም ማስታወቂያ – በ400,000+ ቤተሰቦች',
      offerLabel: 'ለተመራቂዎች ልዩ ዋጋ፡',
      offerPrice: '20% ቅናሽ – ₪1,200 በወር',
      offerPriceBold: '20% ቅናሽ',
      offerPriceRest: ' – ₪1,200 በወር',
      offerDetail: 'አንድ እቅድ – 20 ሰከንድ ማስታወቂያ፣ 4K ዲዛይን እና ድርጊት ጥሪ።',
      ctaJoin: 'ቅናሹን ይቀላቀሉ',
      sectionBenefits: 'ምን ያገኛሉ',
      benefit1Title: 'በPartner TV መገኘት',
      benefit1Text: 'በ400,000+ ቤተሰቦች በሚመለከቱበት ጊዜ ትጋት',
      benefit2Title: '4K ዲዛይን',
      benefit2Text: 'ፕሪሚየም ብራንዲንግ እና ፕሮፌሽናል ድርጊት ጥሪ',
      benefit3Title: 'ልዩ ቅናሽ',
      benefit3Text: '20% ቅናሽ – ₪1,200 በወር፣ ለቴክኒየን ተመራቂዎች ብቻ',
      faqTitle: 'ተደጋግሞ የሚጠየቁ ጥያቄዎች',
      faq1Q: 'ይህ ቅናሽ ለማን ነው?',
      faq1A: 'ልዩ ቅናሹ ለቴክኒየን – የእስራኤል ቴክኖሎጂ ኢንስቲትዩት ተመራቂዎች ቢዝነስ ወይም አገልግሎት በPartner TV ለማስታወቅ ለሚፈልጉ ነው።',
      faq2Q: 'ማስታወቂያው ምን ያካትታል?',
      faq2A: 'በPartner TV የ20 ሰከንድ ፕሪሚየም ማስታወቂያ – ፕሪሚየም ብራንዲንግ፣ 4K ዲዛይን። ብራንድህ በእስራኤል በ400,000+ ቤተሰቦች ይገኛል።',
      faq3Q: 'ቅናሹን እንዴት እንቅማለላለሁ?',
      faq3A: '"ቅናሹን ይቀላቀሉ" ጠቅ አድርገህ በWhatsApp ጻፍልን። ቴክኒየን ተመራቂ መሆንህን እናረጋግጣለን ልዩ ዋጋ እንሰጥሃለን።',
      finalTitle: 'ለመጀመር ተዘጋጅተዋል?',
      finalSubtitle: 'ያግኙን እና ቅናሹን እናስተካክልልዎታለን',
      footerText: 'GSRadio · Partner TV',
      whatsappMessage: 'ከቴክኒየን ተመራቂዎች ገጽ መጣሁ – ለልዩ ቅናሹ ዝርዝሮች እፈልጋለሁ',
    },
  },
};

export function getTranslation(lang, section, key) {
  const sectionData = translations[lang]?.[section];
  return sectionData?.[key] ?? translations.he?.[section]?.[key] ?? key;
}
